import React, { useEffect, useState } from 'react'
import Helmet from 'react-helmet'
import { useHistory } from 'react-router-dom'

import cogoToast from 'cogo-toast'

import CaseTypesService from '../../services/CaseTypesService'

const CaseTypeList = ({ user }) => {
  const history = useHistory()
  const [caseTypes, setCaseTypes] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [showInactive, setShowInactive] = useState(false)

  useEffect(() => {
    load()
    // eslint-disable-next-line
  }, [showInactive])

  function load() {
    setIsLoading(true)
    const fetch = showInactive ? CaseTypesService.getAllIncludingInactive() : CaseTypesService.getAll()

    fetch
      .then(data => {
        setCaseTypes(data)
        setIsLoading(false)
      })
      .catch(() => {
        cogoToast.error('Failed to load case types.')
        setIsLoading(false)
      })
  }

  return (
    <div>
      <Helmet title="Case Types | Library" />
      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3>Case Types</h3>
          <div className="d-flex align-items-center">
            <div className="form-check mr-3">
              <input
                id="showInactive"
                type="checkbox"
                className="form-check-input"
                checked={showInactive}
                onChange={e => setShowInactive(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="showInactive">
                Show inactive
              </label>
            </div>
            <button
              id="addCaseTypeBtn"
              className="btn btn-primary"
              onClick={() => history.push('/library/case-types/add')}
            >
              Add Case Type
            </button>
          </div>
        </div>

        {isLoading ? (
          <p>Loading...</p>
        ) : (
          <table className="table table-hover">
            <thead>
              <tr>
                <th>Name</th>
                <th>Allowed Report Types</th>
                <th>Auto-Filed Report Types</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {caseTypes.length === 0 && (
                <tr>
                  <td colSpan={4} className="text-center text-muted">
                    No case types found.
                  </td>
                </tr>
              )}
              {caseTypes.map(ct => (
                <tr
                  key={ct.id}
                  style={{ cursor: 'pointer' }}
                  onClick={() => history.push(`/library/case-types/${ct.id}`)}
                >
                  <td>{ct.name}</td>
                  <td>{ct.allowedReportTypes || <span className="text-muted">—</span>}</td>
                  <td>{ct.autoFiledReportTypes || <span className="text-muted">—</span>}</td>
                  <td>
                    <span className={`badge badge-${ct.isActive ? 'success' : 'secondary'}`}>
                      {ct.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}

export default CaseTypeList
